export default {
  archive: 'You don`t have any projects in your archive of approval requests.',
  arSearch: 'No Approval Requests matched your search.',
  createProject: 'Create AR',
  dashboard: 'You don`t have any approval requests yet.',
  dashboardButton: 'Create AR',
  noARsMatched: 'No Approval Requests matched your search.',
  noDriversMatched: 'No Drivers matched your search.',
};
